<template>


    <div class="flex mt-1 w-full">
            <font-awesome-icon v-if="favAction == 'remove'" icon="heart-broken" class="text-base mr-1 text-gray-600 hover:text-pastel-blue hover:cursor-pointer mt-2" @click="onFavClick" />
            <l-popup icon="heart" placement="bottom-start" class="mt-1 mr-1 text-base" v-if="favAction == 'add'">
                <div class="text-sm flex flex-wrap select-none p-3">
                    <l-input placeholder="Sett inn ett navn" v-model="favLabel" class="bg-white" @keyup.enter.native="onFavClick">
                        <font-awesome-icon v-close-popover slot="suffix" icon="save" class="text-xl text-gray-600 hover:text-pastel-green-600 hover:cursor-pointer" @click="onFavClick" />
                    </l-input>
                </div>
            </l-popup>
        <div class="w-full flex">
            <div class="w-full">
                <v-select v-model="selection" class="style-chooser" :placeholder="placeholder" :options="options" :multiple="multiple" :close-on-select="!multiple" :clear-search-on-select="!multiple" :clearable="clearable">
                    <div slot="no-options">Ingen valgmuligheter</div>
                </v-select>
            </div>
        </div>
        <div class="ml-1 mt-1">
            <font-awesome-icon icon="backspace" class="text-xl text-gray-600 hover:text-pastel-blue hover:cursor-pointer" @click="clearSelection" />
        </div>
    </div>
</template>

<script>
    import LOpenIndicator from "./LOpenIndicator";
    import LDeselect from "./LDeselect";
    import vSelect from "vue-select";
    import LPopup from "@/components/LPopup";
    import { VClosePopover } from "v-tooltip";
    import { LInput } from "@/components/forms";

    vSelect.props.components.default = () => ({
        Deselect: LDeselect,
        OpenIndicator: LOpenIndicator
    });

    export default {
        name: "LSelectFav",
        components: { vSelect, LPopup, LInput },
        props: ["value", "placeholder", "multiple", "options", "clearable", "favAction"],
        data() {
            return {
                selection: this.value,
                favLabel: ""
            };
        },
        directives: {
            "close-popover": VClosePopover
        },
        methods: {
            selected: function (val) {
                this.$emit("input", val);
                this.selection = val;
            },
            clearSelection() {
                this.selection = [];
            },
            onFavClick() {
                this.$emit("favClick", { type: this.favAction, label: this.favLabel });
                this.favLabel = "";
            }
        },
        watch: {
            value: function (val) {
                this.selection = val;
            },
            selection: function (val) {
                this.$emit("input", val);
            }
        }
    };
</script>




<style src="vue-select/dist/vue-select.css"></style>
<style lang="postcss">
    .style-chooser .vs__search::placeholder,
    .style-chooser .vs__dropdown-toggle,
    .style-chooser .vs__dropdown-menu {
        @apply text-xs text-bluegray-300;
    }

    .style-chooser .vs__dropdown-option {
        @apply text-xs text-bluegray-300;
    }

    .style-chooser .vs__dropdown-option--highlight {
        @apply bg-pastel-green-500 text-white;
    }

    .style-chooser .vs__clear,
    .style-chooser .vs__open-indicator {
        @apply text-gray-500 text-xs;
    }

    .style-chooser .vs__deselect {
        @apply text-gray-500 text-3xs;
    }
</style>